"use client"; // Required because we're using hooks and Framer Motion

import { Box } from "@mui/joy";
import { motion, AnimatePresence } from "framer-motion";

interface AnimationWrapper {
    children: any;
}
export default function AnimationWrapper(props: AnimationWrapper) {
    const { children } = { ...props };

    return (
        <Box width={"100%"} flex={1} display={"flex"} sx={{ minWidth: 0 }}>
            {/* <AnimatePresence mode="wait">
                <motion.div
                    key={pathname}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    transition={{ duration: 0.2 }}
                    style={{ width: "100%" }}
                > */}
            {children}
            {/* </motion.div>
            </AnimatePresence> */}
        </Box>
    );
}
